var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"wheel-loading"},[_c('div',{staticClass:"wheel-loading__wheel",style:({
      width: _vm.props.size || '50px',
      height: _vm.props.size || '50px',
      border: ("5px solid " + (_vm.props.color || '#ec3faa')),
      'border-top-color': '#ddd',
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }